import { render, staticRenderFns } from "./BatchOperationReview.vue?vue&type=template&id=678e0a48&scoped=true&"
import script from "./BatchOperationReview.vue?vue&type=script&lang=js&"
export * from "./BatchOperationReview.vue?vue&type=script&lang=js&"
import style0 from "./BatchOperationReview.vue?vue&type=style&index=0&id=678e0a48&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678e0a48",
  null
  
)

export default component.exports